import type { ProfileStat } from './buildProfileStats'
import { Skeleton } from '../ui/skeleton'
import { placeholders } from '../../lib/skeletonUtils'

/**
 * The counts row beside a profile's avatar — "12 festivals · 30 parties · 214 artists".
 * Equal-width columns, so the gaps look even whatever the label lengths.
 */
export function ProfileStats({
  stats,
  loading,
  placeholderCount = 3,
}: {
  stats?: ProfileStat[]
  loading?: boolean
  /** Skeleton columns when there are no stats yet to count. */
  placeholderCount?: number
}) {
  if (loading || !stats) {
    return (
      <div className="mt-2 grid w-full auto-cols-fr grid-flow-col gap-2">
        {placeholders(stats?.length ?? placeholderCount).map((_, i) => (
          <div key={i} className="flex flex-col gap-1">
            <Skeleton className="h-5 w-6" />
            <Skeleton className="h-3 w-12" />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="mt-2 grid w-full auto-cols-fr grid-flow-col gap-2" data-testid="profile-stats">
      {stats.map(stat => {
        const body = (
          <>
            <span className="text-lg font-semibold leading-tight tabular-nums">{stat.value}</span>
            <span className="whitespace-nowrap text-xs text-muted-foreground">{stat.label}</span>
          </>
        )
        return stat.onClick ? (
          <button
            key={stat.key}
            type="button"
            onClick={stat.onClick}
            className="flex flex-col items-start cursor-pointer"
          >
            {body}
          </button>
        ) : (
          <div key={stat.key} className="flex flex-col items-start">
            {body}
          </div>
        )
      })}
    </div>
  )
}
